@let resultValue = result();

@if (resultValue) {
  @if (resultValue.status) {
    <div class="flex w-full justify-center items-center pb-5">
      <app-task-state class="global" [state]="resultValue.status"></app-task-state>
    </div>
  }

  <!-- General -->
  <h4 class="text-lg font-semibold mb-4">General</h4>

  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
    <div
      class="bg-white border border-gray-200 rounded shadow-sm w-full box-border px-4 py-3 relative">
      @if (resultValue.ping) {
        <app-ping-test [result]="resultValue.ping"></app-ping-test>
      } @else {
        <p class="text-center text-white">Ping</p>
        <mib-spinner [overlay]="true"></mib-spinner>
      }
    </div>

    <div
      class="bg-white border border-gray-200 rounded shadow-sm w-full box-border px-4 py-3 relative">
      @if (resultValue.download) {
        <app-bandwith-test [result]="resultValue.download"></app-bandwith-test>
      } @else {
        <p class="text-center text-white">Download Speed</p>
        <mib-spinner [overlay]="true"></mib-spinner>
      }
    </div>

    <div
      class="bg-white border border-gray-200 rounded shadow-sm w-full box-border px-4 py-3 relative">
      @if (resultValue.upload) {
        <app-bandwith-test [result]="resultValue.upload"></app-bandwith-test>
      } @else {
        <p class="text-center text-white">Upload Speed</p>
        <mib-spinner [overlay]="true"></mib-spinner>
      }
    </div>
  </div>

  @if (resultValue.videoBitrate) {
    <!-- Not yet implemented (value is always null) -->
    <app-bitrate-test [result]="resultValue.videoBitrate"></app-bitrate-test>
  }

  @if (resultValue.audioBitrate) {
    <app-bitrate-test [result]="resultValue.audioBitrate"></app-bitrate-test>
  } @else if (resultValue.status === 'success' || resultValue.status === 'failed') {
    <div class="rounded border border-error bg-red-50 px-4 py-3 text-sm text-error mb-8">
      Audio quality test data could not be collected on this device.
    </div>
  }

  <div class="flex flex-wrap [&>*]:flex-[1_1_50%]">
    @if (resultValue.status === 'success' || resultValue.status === 'failed') {
      @if (resultValue.audioBitrate) {
        <app-bitrate-info-test
          [result]="resultValue.audioBitrate"
          type="audio"></app-bitrate-info-test>
      }
      @if (resultValue.videoBitrate) {
        <app-bitrate-info-test
          [result]="resultValue.videoBitrate"
          type="video"></app-bitrate-info-test>
      }

      @if (resultValue.upload && resultValue.download && resultValue.ping) {
        <app-bandwidth-info-test
          [upload]="resultValue.upload"
          [download]="resultValue.download"
          [ping]="resultValue.ping"></app-bandwidth-info-test>
      }
    }
  </div>
}
